/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  var body = document.querySelector("body.template-product");
  if (body) {
    var states = {
      AC: "Acre",
      AL: "Alagoas",
      AP: "Amapá",
      AM: "Amazonas",
      BA: "Bahia",
      CE: "Ceará",
      DF: "Distrito Federal",
      ES: "Espírito Santo",
      GO: "Goiás",
      MA: "Maranhão",
      MT: "Mato Grosso",
      MS: "Mato Grosso do Sul",
      MG: "Minas Gerais",
      PA: "Pará",
      PB: "Paraíba",
      PR: "Paraná",
      PE: "Pernambuco",
      PI: "Piauí",
      RJ: "Rio de Janeiro",
      RN: "Rio Grande do Norte",
      RS: "Rio Grande do Sul",
      RO: "Rondônia",
      RR: "Roraima",
      SC: "Santa Catarina",
      SP: "São Paulo",
      SE: "Sergipe",
      TO: "Tocantins",
    };

    // Validade do cache de taxas por CEP + variante (5 minutos).
    var RATE_CACHE_TTL = 5 * 60 * 1000;

    async function getCepData(cep) {
      const response = await fetch(
        "https://viacep.com.br/ws/" + cep + "/json/"
      );
      const data = await response.json();
      return data;
    }

    var showRates = function (rates, city, state, target) {
      var output = "";
      if (rates === false) {
        if (target == "product") {
          calcError(
            "Nenhum método de entrega encontrado, confira se o CEP informado é válido."
          );
        }
      } else {
        var truck_icon =
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 21.5"><g data-name="Layer 2"><g data-name="Layer 1"><path d="M7.16 17H6a1 1 0 0 1-1-1v-4a1 1 0 0 0-2 0v4a3 3 0 0 0 3 3h1.2a3.48 3.48 0 0 0 6.68 0h6.32a3.48 3.48 0 0 0 6.68 0H29a1 1 0 0 0 1-1v-5a4.91 4.91 0 0 0-.72-2.39l-2.9-4.33A3.08 3.08 0 0 0 24 5h-2.8V3a3 3 0 0 0-3-3H15a1 1 0 0 0 0 2h3.2a1 1 0 0 1 1 1v14h-5.36a3.48 3.48 0 0 0-6.68 0Zm16.34 2.5A1.5 1.5 0 1 1 25 18a1.5 1.5 0 0 1-1.5 1.5ZM21.2 7H24a1.08 1.08 0 0 1 .72.39L26.47 10H21.2Zm0 5h6.56a3.14 3.14 0 0 1 .24 1v4h-1.16a3.47 3.47 0 0 0-4.31-2.35 3.43 3.43 0 0 0-1.33.74ZM12 18a1.5 1.5 0 1 1-1.5-1.5A1.5 1.5 0 0 1 12 18Z"/><path d="M13 1a1 1 0 0 0-1-1H1a1 1 0 0 0 0 2h11a1 1 0 0 0 1-1Zm-3 5a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2Zm-2 4a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2Z"/></g></g></svg>';
        output +=
          '<div class="heading">' +
          truck_icon +
          " Opções de Frete para " +
          city +
          " - " +
          state +
          "</div>";
        output += '<div class="shipping-rates">';
        output += '<div class="rates">';
        Object.keys(rates).forEach((key) => {
          var rate = rates[key];
          var price = parseFloat(rate.price);
          var delivery = "";

          if (price == 0.0) {
            price = "<b>Grátis</b>";
          } else {
            price = price.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            });
          }

          delivery =
            '<div class="rate__info"><span><b>' +
            rate.presentment_name.replace(" (via Shippy)", "") +
            ": </b></span><span><b>" +
            price +
            "</b> Produção + <b>" +
            rate.delivery_days[0] +
            "</b> dias úteis</span></div>";

          output += '<div class="rate">';
          output += delivery;
          output += "</div>";
        });

        output += "</div>";
        output +=
          '<p class="result__information">* O prazo de Produção deste produto é especificado abaixo.</p>';

        output += "</div>";

        if (target == "product") {
          $(".shipping-estimate .result").show().html(output);
        }
      }
    };

    var getCookie = function (name) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + name + "=");
      if (parts.length == 2) return parts.pop().split(";").shift();
    };

    var cartCookie = getCookie("cart");

    var updateCartCookie = function (a) {
      var date = new Date();
      date.setTime(date.getTime() + 14 * 86400000);
      var expires = "; expires=" + date.toGMTString();
      document.cookie = "cart=" + a + expires + "; path=/";
    };

    var resetCartCookie = function () {
      updateCartCookie(cartCookie);
      endLoader();
    };

    var startLoader = function (message = "") {
      var loader_icon =
        '<svg version="1.1" id="L5" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve" style="display: inline-block;width: 30px;"><circle fill="#111" stroke="none" cx="6" cy="50" r="6"><animateTransform attributeName="transform" dur="1s" type="translate" values="0 15 ; 0 -15; 0 15" repeatCount="indefinite" begin="0.1"></animateTransform></circle><circle fill="#111" stroke="none" cx="30" cy="50" r="6"><animateTransform attributeName="transform" dur="1s" type="translate" values="0 10 ; 0 -10; 0 10" repeatCount="indefinite" begin="0.2"></animateTransform></circle><circle fill="#111" stroke="none" cx="54" cy="50" r="6"><animateTransform attributeName="transform" dur="1s" type="translate" values="0 5 ; 0 -5; 0 5" repeatCount="indefinite" begin="0.3"></animateTransform></circle></svg>';
      $(".shipping-estimate .loading").html(loader_icon + message);
      $(".shipping-estimate .result").html("");
    };

    var endLoader = function () {
      $(".shipping-estimate .loading").html("");
    };

    var calcError = function (message) {
      $(".shipping-estimate .loading").html("");
      // .show() é obrigatório: .shipping-estimate .result nasce com display:none
      // no theme.css, então sem isso a mensagem de erro fica invisível.
      $(".shipping-estimate .result")
        .show()
        .html('<span class="error">' + message + "</span>");
    };

    var calculateShipping = function () {
      var product_id = $('input[name="id"]').val();
      var cep = $(".cep-estimate").val().replace(/\D/g, "");

      if (cep.length == 8) {
        startLoader("Calculando frete");

        getCepData(cep)
          .then((data) => {
            var country = "Brazil";
            var state = states[data.uf];
            var city = data.localidade;

            var zip = cep;
            var random = (Math.random() + 1).toString(36).substring(10);

            localStorage.setItem("cepCache", zip);

            startLoader("Calculando frete para " + city + " - " + state);

            cartCookie = getCookie("cart");

            var tempCookieValue =
              tempCookieValue || "temp-cart-cookie___" + Date.now() + random;
            var fakeCookieValue =
              fakeCookieValue || "fake-cart-cookie___" + Date.now() + random;

            if (!cartCookie) {
              updateCartCookie(tempCookieValue);
              cartCookie = getCookie("cart");
            }

            if (!cartCookie || cartCookie.length < 32) {
              calcError(
                "Não foi possível iniciar o cálculo do frete. Recarregue a página e tente novamente."
              );
              return;
            }

            updateCartCookie(fakeCookieValue);

            getRates(parseInt(product_id), country, state, city, zip);

            return;
          })
          .catch(function () {
            endLoader();
          });
      } else {
        calcError("Por favor, insira um CEP válido.");
      }
    };

    $(document).on("click", ".shipping-estimate button", function (e) {
      e.preventDefault();
      calculateShipping();
    });

    $(document).on("keypress", ".shipping-estimate .cep-estimate", function (e) {
      if (e.which === 13) {
        e.preventDefault();
        calculateShipping();
      }
    });

    var getRates = function (variantId, country, state, city, zip) {
      if (typeof variantId === "undefined") {
        return;
      }

      var productQuantity = $(".quantity__input");

      var quantity =
        productQuantity && productQuantity.length
          ? parseInt(productQuantity.first().val())
          : 1;

      if (!quantity || isNaN(quantity)) {
        quantity = 1;
      }

      var addData = {
        id: variantId,
        quantity: quantity,
      };

      var ratesQuery = new URLSearchParams({
        "shipping_address[country]": country,
        "shipping_address[province]": state,
        "shipping_address[zip]": zip,
      });

      // Consulta as taxas com fetch, e não com $.ajax: apps de pixel instalados
      // na loja sobrescrevem XMLHttpRequest.prototype.send e essa versão
      // sobrescrita estoura TypeError, abortando qualquer chamada jQuery.ajax
      // antes de sair do navegador. fetch não passa por esse patch.
      var fetchRates = function (attempt) {
        return fetch("/cart/shipping_rates.json?" + ratesQuery.toString(), {
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error("shipping_rates.json: HTTP " + response.status);
            }

            return response.json();
          })
          .then(function (d) {
            var rates = d && d.shipping_rates ? d.shipping_rates : [];

            // A transportadora (Frenet) às vezes responde vazio na primeira
            // consulta. Só a consulta é repetida — nunca o /cart/add.js, senão
            // o produto entraria várias vezes no carrinho temporário.
            if (!rates.length && attempt < 3) {
              return new Promise(function (resolve) {
                setTimeout(resolve, 800);
              }).then(function () {
                return fetchRates(attempt + 1);
              });
            }

            return rates;
          });
      };

      fetch("/cart/add.js", {
        body: JSON.stringify(addData),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "xmlhttprequest",
        },
        method: "POST",
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("cart/add.js: HTTP " + response.status);
          }

          return response.json();
        })
        .then(function () {
          return fetchRates(0);
        })
        .then(function (rates) {
          if (rates.length) {
            localStorage.setItem(
              "cepCache_" + zip + "_" + variantId,
              JSON.stringify({
                rates: rates,
                city: city,
                state: state,
                expires: Date.now() + RATE_CACHE_TTL,
              })
            );
            showRates(rates, city, state, "product");
          } else {
            showRates(false, false, false, "product");
          }

          resetCartCookie();
        })
        .catch(function (err) {
          console.error("Erro ao calcular frete:", err);
          calcError(
            "Ocorreu um erro durante o calculo do frete, por favor, tente novamente."
          );
          resetCartCookie();
        });
    };

    var getCachedValues = function () {
      var pid = $('input[name="id"]').val();
      var cepCache = localStorage.getItem("cepCache");

      if (cepCache != null) {
        $(".cep-estimate").val(cepCache).trigger("input");

        var rateCache = localStorage.getItem(
          "cepCache_" + cepCache + "_" + pid
        );

        if (rateCache != null) {
          rateCache = JSON.parse(rateCache);
          // Só reexibe o cache enquanto ele ainda é válido. A comparação estava
          // invertida, então a loja mostrava justamente as taxas vencidas.
          if (Date.now() < rateCache["expires"]) {
            showRates(
              rateCache["rates"],
              rateCache["city"],
              rateCache["state"],
              "product"
            );
          } else {
            localStorage.removeItem("cepCache_" + cepCache + "_" + pid);
          }
        }
      }
    };

    getCachedValues();
  }

  // Traduz os rótulos de data do widget de avaliações do Google
  setTimeout(function () {
    $(
      ".meggnoapps_google_reviews_widget_carousel .review_widget_user_details .written_ago a span"
    ).each(function (i, e) {
      if ($(e).text().search("days ago") != -1) {
        $(e).text($(e).text().replace("days ago", "dias atrás"));
      }

      if ($(e).text().search("last month") != -1) {
        $(e).text($(e).text().replace("last month", "mês passado"));
      }

      if ($(e).text().search("months ago") != -1) {
        $(e).text($(e).text().replace("months ago", "meses atrás"));
      }
    });
  }, 12000);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
